import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";



export interface IVposRoutingFileUploadRequest {
  files: File[];
}

async function VposRoutingFileUpload(formData: FormData): Promise<any> {
  try {
    return (await axiosInstance.post("/VposRouting/AddVposRoutingWithExcel", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddVposRoutingFiles() {
  return useMutation<any, Error, FormData>(
    (variables) => VposRoutingFileUpload(variables)
  );
}